'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContextObject = function () {
  /**
   * @param {Function} propertyProvider
   * @param {String} type the context type
   * @param {String} entityId the id of the Deskpro Entity referenced by this context
   * @param {CustomFieldsClient} [customFields] A client for the `CustomFields` API of this Deskpro Object, if supported
   * @param {...*} rest
   * @constructor
   */
  function ContextObject(_ref) {
    var propertyProvider = _ref.propertyProvider,
        type = _ref.type,
        entityId = _ref.entityId,
        customFields = _ref.customFields,
        rest = (0, _objectWithoutProperties3.default)(_ref, ['propertyProvider', 'type', 'entityId', 'customFields']);
    (0, _classCallCheck3.default)(this, ContextObject);

    this.props = (0, _extends3.default)({ propertyProvider: propertyProvider, type: type, entityId: entityId, customFields: customFields }, rest);
  }

  /**
   * Retrieves the value of a custom field field from this object is supported
   *
   * @param {String} id
   * @param {*} defaultValue
   * @return {Promise<String|null|Array<String|null>, Error>}
   */


  (0, _createClass3.default)(ContextObject, [{
    key: 'getCustomField',
    value: function () {
      var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(id) {
        var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        var customFields;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                customFields = this.props.customFields;

                if (customFields) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt('return', _promise2.default.reject(new Error('this object does not support custom fields')));

              case 3:
                return _context.abrupt('return', customFields.getField(id, defaultValue));

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getCustomField(_x) {
        return _ref2.apply(this, arguments);
      }

      return getCustomField;
    }()

    /**
     * A client for the `CustomFields` API of this context
     * This property is null when the object does not support custom fields
     *
     * @public
     * @return {CustomFieldsClient|null}
     */

  }, {
    key: 'get',


    /**
     * Retrieves a property from this object
     *
     * @param {String} [property]
     * @return {Promise<*>}
     */
    value: function () {
      var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(property) {
        var path;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(property && typeof property !== 'string')) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt('return', _promise2.default.reject(new Error('property must be a string')));

              case 2:
                path = property ? property.split('.') : [];
                return _context2.abrupt('return', this.props.propertyProvider({ path: path, type: this.props.type }));

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function get(_x3) {
        return _ref3.apply(this, arguments);
      }

      return get;
    }()

    /**
     * The type of this context
     *
     * @public
     * @return {String}
     */

  }, {
    key: 'customFields',
    get: function get() {
      if (!this.props.customFields) {
        return null;
      }

      return this.props.customFields;
    }
  }, {
    key: 'type',
    get: function get() {
      return this.props.type.toString();
    }

    /**
     * The id of the Deskpro Entity which belongs to this context.
     *
     * For example if the `type` is `ticket`, then this is the id of `Ticket` Entity
     *
     * @public
     * @return {String}
     */

  }, {
    key: 'id',
    get: function get() {
      return this.props.entityId.toString();
    }
  }]);
  return ContextObject;
}();

exports.default = ContextObject;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@deskpro/apps-sdk-core/lib/main/javascript/Core/ContextObject.js
// module id = 323
// module chunks = 0